module.exports = __webpack_public_path__ + "static/img/image2.cfee280.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/image2.jpeg
// module id = 0SpW
// module chunks = 26